import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

const FloatingCTA = () => {
  const { theme } = useTheme();
  const [visible, setVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setVisible(true); // always visible on desktop
      return;
    }

    const cycle = () => {
      setVisible(false); // hide
      setTimeout(() => setVisible(true), 5000); // show after 5s
    };

    const interval = setInterval(cycle, 8000); // 5s hidden + 3s visible

    return () => clearInterval(interval);
  }, [isMobile]);

  return (
    <div
      className={`fixed bottom-3 right-3 sm:bottom-4 sm:right-4 z-[9999] w-[200px] sm:w-[260px] max-w-[calc(100vw-1.5rem)] box-border transition-all duration-500 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        className={`
          backdrop-blur-xl
          border border-gray-200
          rounded-2xl
          shadow-lg
          p-3
          ${theme === "dark" ? "bg-black/60" : "bg-white/90"}
        `}
      >
        {/* Apply Button */}
        <Link
          to="/contact"
          className="
            w-full
            bg-orange-500
            hover:bg-orange-600
            text-white
            text-xs sm:text-sm
            font-semibold
            py-2 sm:py-2.5
            rounded-lg sm:rounded-xl
            transition
            flex items-center
            justify-center
            gap-2
          "
        >
          Apply now →
        </Link>

        {/* Free Plan */}
        <Link
          to="/contact"
          className={`
            mt-2
            w-full
            border border-gray-200
            text-xs sm:text-sm
            font-medium
            py-2 sm:py-2.5
            rounded-lg sm:rounded-xl
            transition
            flex items-center
            justify-center
            gap-2
            hover:bg-gray-100
            ${
              theme === "dark"
                ? "text-white hover:bg-white/10"
                : "text-black bg-gray-50"
            }
          `}
        >
          Free plan ✨
        </Link>
      </div>
    </div>
  );
};

export default FloatingCTA;
